export const captureVideoFrame = (
  video: HTMLVideoElement,
  canvas: HTMLCanvasElement,
  scale: number = 1.0
): void => {
  const ctx = canvas.getContext('2d', {
    willReadFrequently: true,
    alpha: false,
    desynchronized: true,
  });
  if (!ctx) {
    throw new Error('Failed to get canvas context');
  }

  // Set canvas dimensions based on scale factor
  canvas.width = video.videoWidth * scale;
  canvas.height = video.videoHeight * scale;

  // Draw the current video frame to canvas
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
};
